module.exports = __webpack_public_path__ + "./docs/img/tooltip.b7af59acadaf44a3575d83f4b96654da.svg";